import * as React from "react";
import AccountsPage from "../accounts/components/pages/AccountsPage";

const ExchangesScreen: React.FC = () => <AccountsPage accountType="exchange" />;

export default ExchangesScreen;
